export const faqs = [
  {
    id: 1,
    q: "网红反差是什么意思？",
    a: "网红反差指的是同一位博主在不同阶段呈现出的形象差距，比如早期素人时期的随手自拍，与近期有团队拍摄的精修图放在一起时形成的强烈对照。本站把这类对比按同一位创作者整理成组，方便一次性看清变化的来龙去脉。",
  },
  {
    id: 2,
    q: "前后对比的素材都从哪里来？",
    a: "素材全部来自博主本人公开发布的内容，包括早期动态、公开活动露面以及近期的更新。我们只做整理与并置，不进行任何后期篡改，也不使用非公开渠道获得的图片。",
  },
  {
    id: 3,
    q: "反差指数是怎么算出来的？",
    a: "反差指数是本站结合造型风格、妆容成熟度、镜头表现力、后期修图程度四个维度给出的相对评分，满分 100。它只用于横向比较同一批收录对象，不代表任何对个人容貌的评价。",
  },
  {
    id: 4,
    q: "收录的博主资料会持续更新吗？",
    a: "会。已收录的对象我们会尽量追踪其后续公开内容，把新的节点补进时间线。你也可以在联系我们页面提交想看的对象，编辑团队会按线索热度排期整理。",
  },
  {
    id: 5,
    q: "发现对比内容有误怎么办？",
    a: "如果你发现年份标注、账号名称或图片对应关系有出入，欢迎通过联系页面反馈。核实后我们会尽快修正，并保留修改记录。",
  },
  {
    id: 6,
    q: "网站为什么要做形象对比？",
    a: "很多人好奇的不是\"谁变好看了\"，而是\"一个人是怎么一步步找到自己风格的\"。我们更希望这组内容是一份风格成长档案，而不是一场容貌评审。",
  },
];